import $ from "jquery";
import 'popper.js';
import 'bootstrap';

$('#articles').on('click', '#load-older-posts', function(e) {
  // prevent new page load
    e.preventDefault();

  // store next page number
    var next_page = $(this).attr('href');

  // remove older posts button from DOM
    $('.load-more').remove();

  // ajax older posts below existing posts
    $('#articles').append(
      $('<div />').load(next_page + ' #articles')
    );
});

// Accordion scripts

document.addEventListener("DOMContentLoaded", function(event) {
var acc = document.getElementsByClassName("accordion");
var panel = document.getElementsByClassName('panel');

for (var i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
        var setClasses = !this.classList.contains("active");
        setClass(acc, "active", "remove");
        setClass(panel, "show", "remove");

        if (setClasses) {
            this.classList.toggle("active");
            this.nextElementSibling.classList.toggle("show");
        }
    }
}

function setClass(els, className, fnName) {
    for (var i = 0; i < els.length; i++) {
        els[i].classList[fnName](className);
    }
}

});

jQuery(document).ready(function($) {
  $('#gform_wrapper_0 .gform_title').replaceWith('<h3 class="gform_title">Sign in to Your Account</h3>');
  $('#gform_wrapper_0 #gform_submit_button_0').val('Sign In');
});

jQuery(document).ready(function($) {
  $("#search-toggle").on("click", function() {
    $(".searchform").toggleClass("open");
    $("#search-toggle").toggleClass("open");
    $(".main-nav").toggleClass("open");
  });
});

jQuery(document).ready(function($) {
  $(".toggler-menu").on("click", function() {
    $(this).toggleClass("close-label");
  });
});

jQuery(document).ready(function($) {
  $(".navbar-menu-toggler").click(function(){
     $(this).next().toggleClass("open");
     $(this).toggleClass("rotate");
  });
});

jQuery(document).ready(function($) {
  $(".read-more").on("click", function() {
    $(this).addClass("hide");
    $(this).next().toggleClass("open");
  });
});

jQuery(document).ready(function($) {
  $(".read-less").on("click", function() {
    $(this).parent('.staff-expanded-bio').toggleClass("open");
    $(this).parent('.staff-expanded-bio').prev('.read-more').toggleClass("hide");
  });
});
